import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Flexer } from '../dashboard/elements/LayoutElements';

// export const DevPage = () => {
//     return <Flexer padding="10">
//         <MenuButton block label="Test Menu">
//             <Flexer width="12">
//                 <Menu>
//                     <Menu.Section first >
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                     </Menu.Section>
//                     <Menu.Section >
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                             <Menu.ItemPush>
//                                 <Menu.Badge>Test</Menu.Badge>
//                             </Menu.ItemPush>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                             <Menu.ItemPush>
//                                 <Menu.Badge>Test</Menu.Badge>
//                             </Menu.ItemPush>
//                         </Menu.Item>
//                     </Menu.Section>
//                     <Menu.Section >
//                         <Menu.Item>
//                             <Icon size="1.5" src="deqo://icons/hero/exclamation-circle" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                         </Menu.Item>
//                         <Menu.Item>
//                             <NoIcon size="1.5" />
//                             <Menu.ItemText>Test</Menu.ItemText>
//                             <Menu.ItemPush>
//                                 <Menu.Badge>Test</Menu.Badge>
//                             </Menu.ItemPush>
//                         </Menu.Item>
//                     </Menu.Section>
//                 </Menu>
//             </Flexer>
//         </MenuButton>
//     </Flexer>;
// };

export const DevPage = () => {
    return <Flexer> </Flexer>;

};
